import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../constants/Languages.js';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactDOM from 'react-dom';

//import components
import PageHeaderCard from './common/PageHeaderCard.js';
import CardHeader from './common/CardHeader.js';
import CardSwitch from './common/CardSwitch.js';
import CardSection from './common/CardSection.js';
import ItemYearbook from './ItemYearbook.js';
import ItemBreadcrumbs from '../ItemBreadcrumbs.js';
import ItemNavigation from '../ItemNavigation.js';

import { getTextMetadataDataTransformed } from '../../../scripts/TextMetadata.js';

class ItemCard extends Component {
	withTabs = [ 'journal', 'journal-number' ];

	constructor(props) {
		super(props);

		this.state = {
			isYearbookButton: false,
			selectedTab: 0,
		};
	};

	componentDidMount() {
		this.domNode = ReactDOM.findDOMNode(this.tabList);
		this.handleScroll();
		window.addEventListener('scroll', this.handleScroll);
	};

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	};

	handleScroll = (event) => {
		const { type } = this.props;
		if (this.domNode && this.withTabs.includes(type)) {
			this.tabListOffset = this.domNode.getBoundingClientRect();
			this.setState({ isYearbookButton: this.tabListOffset.y + this.tabListOffset.height < 0 });
		}
	};

	setTab = (index) => {
		this.setState({ selectedTab: index });
	};

	setTabBtn = (index) => {
		this.setTab(index);
		window.scrollTo(0, 0);
	};

	groupArr = (arr) => {
		const newArr = [];

		arr.forEach(function (listItem) {
			if (newArr.filter(elem => elem.type === listItem.entityType).length < 1) {
				newArr.push({ type: listItem.entityType, values: [ listItem ] });
			} else {
				newArr.map(elem => elem.type === listItem.entityType ?
					{
						...elem,
						values: elem.values.push(listItem)
					} : elem);
			}
		});
		return newArr;
	};

	render() {
		const { clang, type, creationTime, id, types, showBackButton, history, allNames,
			edition, locations, date, organizers, awards, belongingToEventSeries, linkedFilesAndRecords, headings,
			secondaryHeadings, annotations, externalLinks, relations, names, groupAlias, authorCompany, birthDate,
			birthLocation, deathDate, deathLocation, sex, title, titles, characters, publicationFrequency,
			triggerInstitutions, publishingHouses, places, publishingSeries, issn, physicalDeficiencies, journal,
			journalYears, publishedFromTo, origin, authors, interviewParts, mailingParts, sources, name, otherNames, recordsNumber, journalSubtitle } = this.props;
		const { isYearbookButton, selectedTab, headingsSelect } = this.state;

		const baseTitleName = allNames ? allNames.filter(title => title.type === 'base')[ 0 ] : false;
		const parallelTitle = allNames ? allNames.filter(title => title.type === 'parallel')[ 0 ] : false;
		const otherTitleNames = allNames ? allNames.filter(title => title.type === 'other') : false;

		const unitTitle = titles ? titles.filter(title => title.type === 'base')[ 0 ] : false;
		const baseTitle = title && unitTitle ? { label: title } : titles ? titles.filter(title => title.type === 'base')[ 0 ] : false;
		const dedication = titles ? titles.filter(title => title.type === 'dedication')[ 0 ] : false;
		const otherTitle = titles ? titles.filter(title => title.type === 'other')[ 0 ] : false;
		const translationBase = titles ? titles.filter(title => title.type === 'translation-base')[ 0 ] : false;
		const originalTitle = titles ? titles.filter(title => title.type === 'original')[ 0 ] : false;
		const incipit = baseTitle && titles ? titles.filter(title => title.type === 'incipit')[ 0 ] : false;
		const incipitTitle = !baseTitle && titles ? titles.filter(title => title.type === 'incipit')[ 0 ] : false;

		const mainName = names ? names.filter(name => name.type === 'main-name') : false;
		const familyName = names ? names.filter(name => name.type === 'family-name') : false;
		const otherLastOrFirstName = names ? names.filter(name => name.type === 'other-last-name-or-first-name') : false;
		const monasticName = names ? names.filter(name => name.type === 'monastic-name') : false;
		const codename = names ? names.filter(name => name.type === 'codename') : false;
		const alias = names ? names.filter(name => name.type === 'alias') : false;

		const additionTo = relations ? relations.filter(name => name.type === 'subordinate').map(elem => elem.target) : false;
		const contains = relations ? relations.filter(name => name.type === 'parent').map(elem => elem.target) : false;
		const previous = relations ? relations.filter(name => name.type === 'previous').map(elem => elem.target) : false;
		const next = relations ? relations.filter(name => name.type === 'next').map(elem => elem.target) : false;

		const cardName = baseTitleName ? baseTitleName.label : false
			|| baseTitle ? baseTitle.label : false
				|| incipitTitle ? incipitTitle.label : false
					|| mainName ? mainName.label : false
						|| name ? name.label : false
		|| title;

		const newAwards = awards ? awards.map(award => { return { ...award, linkedFilesAndRecords: this.groupArr(award.linkedFilesAndRecords) } }) : false;

		const newInterviewParts = interviewParts && interviewParts.length ?
			{
				'items': interviewParts.map(descItem =>
					[
						{ type: 'interInterviewer', values: descItem.interviewer.authors.concat(descItem.interviewer.institutions) },
						{ type: 'interInterlocutor', values: descItem.interlocutor.authors.concat(descItem.interlocutor.institutions) },
					].filter(descItem => descItem.values.length)
				).filter(descItem => descItem.length)
			} : false;

		const newMailingParts = mailingParts && mailingParts.length ?
			{
				'items': mailingParts.map(descItem =>
					[
						{ type: 'mailSender', values: descItem.sender.authors.concat(descItem.sender.institutions) },
						{ type: 'mailAddressee', values: descItem.addressee.authors.concat(descItem.addressee.institutions) },
						{ type: 'mailDescription', values: [ { label: descItem.description } ] },
					].filter(descItem => descItem.values.length)
				).filter(descItem => descItem.length)
			} : false;

		const detailsData = [
			{ label: 'namePeriodInfoCycle', val: type === 'event-series' && name ? name.periodInfo : false },
			{ label: 'namePeriodInfo', val: type !== 'event-series' && name ? name.periodInfo : false },
			{ label: 'namePlaces', val: type === 'institution' && name ? name.places : false },
			{ label: 'otherNames', val: type === 'event-series' ? otherNames : false },
			{ label: 'otherNamesInstitution', val: type === 'institution' ? otherNames : false },
			{ label: 'typesSeries', val: type === 'series' ? types : false },
			{ label: 'typesInstitution', val: type === 'institution' ? types : false },
			{ label: 'authors', val: authors },
			{ label: 'baseTitle', val: type !== 'journal-number' && type !== 'journal' ? baseTitle : false },
			{ label: 'incipitTitle', val: incipitTitle },
			{ label: 'incipit', val: incipit },
			{ label: 'translationBase', val: translationBase },
			{ label: 'translationBaseLang', val: translationBase ? translationBase.language : false },
			{ label: 'originalTitle', val: originalTitle },
			{ label: 'titleOriginalLang', val: originalTitle ? originalTitle.language : false },
			{ label: 'otherTitleEvent', val: type === 'event' ? otherTitleNames : false },
			{ label: 'otherTitle', val: otherTitle },
			{ label: 'typesEvent', val: type === 'event' ? types : false },
			{ label: 'typesEventSeries', val: type === 'event-series' ? types : false },
			{ label: 'edition', val: edition },
			{ label: 'locationsEvent', val: type === 'event' ? locations : false },
			{ label: 'dateEvent', val: type === 'event' ? date : false },
			{ label: 'organizersEvent', val: type === 'event' ? organizers : false },
			{ label: 'organizers', val: type !== 'event' ? organizers : false },
			{ label: 'awards', val: newAwards },
			{ label: 'belongingToEventSeries', val: belongingToEventSeries },
			{ label: 'relationsEvent', val: type === 'event' ? relations : false },
			{ label: 'relationsEventSeries', val: type === 'event-series' ? relations : false },
			{ label: 'relationsInstitution', val: type === 'institution' ? relations : false },
			{ label: 'mainName', val: mainName },
			{ label: 'alias', val: alias },
			{ label: 'familyName', val: familyName },
			{ label: 'monasticName', val: monasticName },
			{ label: 'codename', val: codename },
			{ label: 'otherName', val: otherLastOrFirstName },
			{ label: 'groupAlias', val: groupAlias },
			{ label: 'unitTitle', val: type === 'journal-number' ? unitTitle : false },
			{ label: 'dedication', val: dedication },
			{ label: 'additionTo', val: type === 'journal' || type === 'journal-item' ? additionTo : false },
			{ label: 'contains', val: type === 'journal' || type === 'journal-item' ? contains : false },
			{ label: 'previousTitle', val: type === 'journal' || type === 'journal-item' ? previous : false },
			{ label: 'nextTitle', val: type === 'journal' || type === 'journal-item' ? next : false },
			{ label: 'characters', val: characters },
			{ label: 'publicationFrequency', val: publicationFrequency },
			{ label: 'triggerInstitutions', val: triggerInstitutions },
			{ label: 'publishingHouses', val: publishingHouses },
			{ label: 'places', val: places },
			{ label: 'publishedFromTo', val: publishedFromTo },
			{ label: 'publishingSeries', val: publishingSeries },
			{ label: 'issn', val: issn },
			{ label: 'physicalDeficiencies', val: physicalDeficiencies },
			{ label: 'authorCompany', val: authorCompany },
			{ label: 'birthDate', val: birthDate },
			{ label: 'birthLocation', val: birthLocation },
			{ label: 'deathDate', val: deathDate },
			{ label: 'deathLocation', val: deathLocation },
			{ label: 'sex', val: sex },
			{ label: 'linkedFilesAndRecords', val: linkedFilesAndRecords ? this.groupArr(linkedFilesAndRecords) : false },
			{ label: 'headings', val: headings },
			{ label: 'secondaryHeadings', val: secondaryHeadings },
			{ label: 'mailingParts', val: newMailingParts.items && newMailingParts.items.length ? newMailingParts : false },
			{ label: 'interviewParts', val: newInterviewParts.items && newInterviewParts.items.length ? newInterviewParts : false },
			{ label: 'annotations', val: getTextMetadataDataTransformed(annotations) },
			{ label: 'sources', val: sources },
		].filter(dataItem => Array.isArray(dataItem.val) ? dataItem.val.length : dataItem.val);;

		const externalLinksData = externalLinks && externalLinks.length ?
			externalLinks.map(link => {
				return {
					label: link.label,
					val: {
						label: link.link,
						link: link.link,
						desc: link.description
					}
				}
			})
			: false;

		const originData = origin && origin.length ?
			origin.map(item => {
				return {
					label: item.entityType,
					val: item
				}
			}
			)
			: false;


		const getSections = () => {
			if (!detailsData.length && !originData && !externalLinksData) {
				return <div className="card__no-data">{ lang[ clang ].item.no_info }</div>;
			}

			return <div className="card__sections">
				{ detailsData.length &&
					<CardSection label="details_card" data={ detailsData } type={ type } /> }
				{ originData &&
					<CardSection label="provenance" data={ originData } type={ type } /> }
				{ externalLinksData &&
					<CardSection label="external_links" data={ externalLinksData } type={ type } /> }
			</div>
		};

		const setHeadingOption = (option) => {
			const { headingsSelect } = this.state;

			if (option && option.value !== headingsSelect) {
				this.setState({ headingsSelect: option.value });
			}
		};

		const breadcrumbsList = [ { label: 'home' }, { label: 'cards', link: '/files' }, { label: type, link: `/files/search?q=*&area=${type}` }, type === 'journal-number' && journal ? { label: journal.label, link: `/item/journal/${journal.link}` } : '' ];

		return (
			<div className="card">
				<ItemBreadcrumbs list={ breadcrumbsList } currentPage={ cardName } />
				<div className="card-container">
					<PageHeaderCard name={ lang[ clang ].item.types[ type ] } type={ type } />
					<ItemNavigation history={ history } showBackButton={ showBackButton } />
					<Tabs className={ `card__tabs ${this.withTabs.includes(type) ? 'with-tabs' : ''}` } selectedIndex={ selectedTab } onSelect={ this.setTab }>
						{ this.withTabs.includes(type) &&
							<TabList className="card__tabs-list" ref={ el => this.tabList = el }>
								<Tab className="card__tab card__tab-1" selectedClassName="active">
									<button>
										{ lang[ clang ].item.details_tab }
									</button>
								</Tab>
								{ journalYears && journalYears.length > 0 &&
									<Tab className="card__tab card__tab-2" selectedClassName="active">
										<button>
											{ lang[ clang ].item.yearbook_desc_tab }
										</button>
									</Tab> }
							</TabList> }
						<div className="card__content">
							<CardHeader
								cardName={ type === 'journal-number' && journal && selectedTab === 1 ? journal.label : cardName }
								parallelName={ parallelTitle || { label: journalSubtitle } }
								creationTime={ creationTime } id={ id } />
							<CardSwitch
								headings={ headings }
								val={ headingsSelect }
								setHeadingOption={ setHeadingOption }
								id={ id }
								type={ type } />
							{ !this.withTabs.includes(type) && getSections() }
							{ this.withTabs.includes(type) &&
								<TabPanel>
									{ getSections() }
								</TabPanel> }
							{ this.withTabs.includes(type) && journalYears && journalYears.length > 0 &&
								<TabPanel>
									<ItemYearbook years={ journalYears } recordsNumber={ recordsNumber } cardId={ id } />
								</TabPanel> }
						</div>
					</Tabs>
					{ isYearbookButton && this.withTabs.includes(type) && journalYears && journalYears.length > 0 &&
						((selectedTab !== 0 &&
							<button className="card__yearbook-button" onClick={ () => this.setTabBtn(0) }>
								{ lang[ clang ].item.details_tab }
							</button>) ||
							(selectedTab !== 1 &&
								<button className="card__yearbook-button" onClick={ () => this.setTabBtn(1) }>
									{ lang[ clang ].item.yearbook_desc }
								</button>)) }
				</div>
			</div>
		);
	};
};

ItemCard.propTypes = {
	clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemCard);



// WEBPACK FOOTER //
// ./src/components/items/cards/ItemCard.js